<template>
  <v-dialog max-width="30%" persistent :value="dialogStatus" @input="$emit('input', $event)">
    <v-layout wrap class="white">
      <span class="pt-2 px-2 body-2">{{title}}</span>
      <v-spacer></v-spacer>
      <v-btn small dark icon color="grey" @click.native="dialogStatus = false">
        <v-icon small>$vuetify.icons.rms_close</v-icon>
      </v-btn>
    </v-layout>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      class="pa-0"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      @vdropzone-success="successUpload"
      @vdropzone-thumbnail="setThumbnail"
      @vdropzone-error="showError"
      @vdropzone-sending="appendData"
    >
      <div class="dropzone-custom-content">
        <v-icon color="secondary" style="font-size: 70px">mdi-cloud-upload</v-icon>
        <h2
          color="blue"
          class="dropzone-custom-title"
        >{{$t('screener.admin.drag_and_drop.message')}}</h2>
        <div class="subtitle">{{$t('screener.admin.drag_and_drop.subtitle')}}</div>
        <div class="py-4 caption secondary--text" v-if="warning" v-html="warning"></div>
      </div>
    </vue-dropzone>
  </v-dialog>
</template>
<script>
// import from local copy
import vue2Dropzone from '@/components/local/vue2-dropzone/src/index.js';
import '@/components/local/vue2-dropzone/dist/vue2Dropzone.min.css';
import DEFINES from "@/defines";

export default {
  name: "SingleFileUploader",
  props: ["value", "title", "attribute", "dropzoneOptions", "warning","collection", "model_id"],
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
    dialogStatus: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    dialogStatus: function() {
      if (this.dialogStatus) {
        this.$refs.myVueDropzone.removeAllFiles();
      }
    }
  },
  methods: {
    successUpload(file, response) {
      this.dialogStatus = false;
      this.$refs.myVueDropzone.removeAllFiles();
      this.$emit("successUpload",response);
    },

    setThumbnail(file, dataUrl) {
      this.$emit("setThumbnal", {
        on: this.attribute,
        value: dataUrl
      });
    },

    appendData(file, xhr, formData) {
      formData.append('collection', this.collection);
      if(this.model_id){
        formData.append('model_id', this.model_id);
      }
    },

    showError(file, message, xhr) {
      this.$emit("onError", {
        file,
        message,
        xhr
      });
    }
  }
};
</script>
